import component from './offers.component';
import routes from './offers.routes';

export default angular
  .module('fizyweb.paycell.noauth.offers', [])
  .component('fizyPaycellNoAuthOffers', component)
  .config(routes).name;


// WEBPACK FOOTER //
// src/app/no-auth/offers/offers.module.ts